import { StakingPlatform, EthStats, StakingPlatformTVL } from '../../types/stakingPlatform'

export async function getStakingPlatforms(): Promise<StakingPlatform[]> {
  const url = new URL(`${process.env.NEXT_PUBLIC_STRAPI_URL}/staking-platforms`)
  const res = await fetch(url.toString())
  if (res.status !== 200) {
    return []
  }

  const data = (await res.json()) as StakingPlatform[]

  return data
}

export async function getEthStats(): Promise<EthStats> {
  const url = new URL(
    `https://api.cryptostats.community/api/v1/eth-beacon-chain/currentAPY,tvlUSDCurrent,tvlETHCurrent,totalRewards,totalStakedETH`,
  )

  const res = await fetch(url.toString())

  if (res.status !== 200) {
    return {
      stakedEth: 0,
      APY: 0,
      stakedEthDollars: 0,
    }
  }

  const data = await res.json()

  const stakedEth = data?.data[0]?.results?.totalStakedETH || 0
  const stakedEthDollars = data?.data[0]?.results?.tvlUSDCurrent || 0
  const APY = data?.data[0]?.results?.currentAPY || 0

  return {
    stakedEth: Number.parseFloat(stakedEth),
    stakedEthDollars: Number.parseFloat(stakedEthDollars.toFixed(2)),
    APY: Number.parseFloat((APY * 100).toFixed(2)),
  }
}

export async function getStakingPlatformTVLS(): Promise<StakingPlatformTVL[]> {
  const url = new URL(
    `https://api.cryptostats.community/api/v1/eth-staking-pools/apy,totalStakedETH?metadata=false`,
  )
  const res = await fetch(url.toString())

  if (res.status !== 200) {
    return []
  }

  const data = await res.json()

  return data?.data || ([] as StakingPlatformTVL[])
}

export async function getEthPrice(): Promise<number | undefined> {
  let price = undefined

  if (window.localStorage) {
    price = window.localStorage.getItem('ethPrice')
    const lastSet = window.localStorage.getItem('ethPriceDate')
    if (price && lastSet) {
      // if price is fetched today, return it
      if (Date.now() < new Date(lastSet).getTime() + 1000 * 60 * 60 * 24) {
        return Number.parseFloat(price)
      }
    }
  }

  // only fetch price if we don't have it in localStorage, or it's older than 24 hours
  const url = new URL(
    `https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd`,
  )
  const res = await fetch(url.toString())

  if (res.status !== 200) {
    return undefined
  }

  const data = await res.json()

  price = data?.ethereum?.usd ? Number(data.ethereum.usd) : undefined

  if (window.localStorage) {
    if (price) {
      window.localStorage.setItem('ethPrice', price.toString())
      window.localStorage.setItem('ethPriceDate', new Date().toISOString())
    }
  }
  return price
}

export default getStakingPlatforms
